import { Transform } from 'class-transformer';
import { centTransform, dateTransform } from '../utils/helper';

export class Movement {
	id!: number;
	userid!: number;
	createdby!: number;
	fromaccount?: string;
	fromaccountdescr?: string;
	toaccount?: string;
	toaccountdescr?: string;
	@Transform(dateTransform)
	insdate!: Date;
	@Transform(dateTransform)
	moddate!: Date;
	@Transform(dateTransform)
	accrualstart!: Date;
	@Transform(dateTransform)
	accrualstop!: Date;
	year!: number;
	movtype!: string;
	@Transform(dateTransform)
	movdate!: string;
	progressivenumber!: number;
	activitytype!: string;
	paymode!: string;
	costcenter!: string;
	reason!: string;
	note!: string;
	protocol!: string;
	@Transform(centTransform)
	amount!: number;
	hqid!: number;
	eid?: number;
	entity?: string;
	
	get isIncoming() {
		return Object.keys(MovementAccountPrefix).map(
			// @ts-ignore
			k => MovementAccountPrefix[k]).indexOf(this.fromaccount[0]) >= 0;
	}
	
	get isOutgoing() {
		return Object.keys(MovementAccountPrefix).map(
			// @ts-ignore
			k => MovementAccountPrefix[k]).indexOf(this.toaccount[0]) >= 0;
	}
}

export class Accountable {
	eid!: number;
	entity!: string;
	fullname!: string;
	account!: string;
}

export enum MovementActivityType {
	COMMERCIAL = 'commercial',
	INSTITUTIONAL = 'institutional'
}

export enum MovementType {
	STANDARD = 'standard',
	ASSOCIATE = 'associate'
}

export enum MovementAccountPrefix {
	ACTOR = 'A',
	USER = 'U',
	CONTACT = 'C'
}